import Html from './HtmlHelper.js';

class DealerForm {
    _httpClient;
    _modal;
    _formContainer;
    _openBtnMobile;
    _openBtnDesktop;
    _closeBtn;
    _modelNameContainer;
    _visualisationControls;
    _visualisationContainer;
    _visualisationViewer;
    _swipeZone;

    constructor(httpClient, modal) {
        this._httpClient = httpClient;
        this._modal = modal;
        this._init();
    }

    _init() {
        this._formContainer = Html.select('.send-to-dealer-overlay');
        this._openBtnMobile = Html.getById('share-with-dealer-btn-mobile');
        this._openBtnDesktop = Html.getById('share-with-dealer-btn');
        this._closeBtn = Html.select('.send-to-dealer-overlay .icon-close-wrapper');
        this._modelNameContainer = Html.select('.model-name-container');
        this._visualisationControls = Html.select('.visualisation-controls');
        this._visualisationContainer = Html.getById('visualisation-container');
        this._visualisationViewer = Html.getById('visualisationviewer');
        this._swipeZone = Html.select('.swipezone');

        this._openBtnMobile.addEventListener('click', this.show.bind(this));
        this._openBtnDesktop.addEventListener('click', this.show.bind(this));
        this._closeBtn.addEventListener('click', this.hide.bind(this));
    }

    async show() {
        await this._addConfigurationDataToHiddenInputs();

        this._modelNameContainer.classList.remove('is-active');
        this._visualisationControls.classList.remove('is-active');
        this._visualisationContainer.classList.remove('is-active');
        this._visualisationViewer.classList.remove('is-active');
        this._swipeZone.classList.remove('is-active');
        this._formContainer.classList.add('is-active');
    };

    hide() {
        this._modelNameContainer.classList.add('is-active');
        this._visualisationControls.classList.add('is-active');
        this._visualisationContainer.classList.add('is-active');
        this._visualisationViewer.classList.add('is-active');
        this._swipeZone.classList.add('is-active');
        this._formContainer.classList.remove('is-active');
    }

    async _addConfigurationDataToHiddenInputs() {
        const dossierId = Html.select('.otc-main')?.dataset.dossier;
        const shareKey = await this._getShareKey(dossierId);
        const flow = Html.getById('Flow')?.value;

        const dossierIdHiddenInput = Html.getById('OtcDealer_DossierId');
        const flowHiddenInput = Html.getById('OtcDealer_Flow');
        const shareKeyHiddenInput = Html.getById('OtcDealer_ShareKey');

        dossierIdHiddenInput.value = dossierId;
        flowHiddenInput.value = flow;
        shareKeyHiddenInput.value = shareKey;
    }

    async _getShareKey(dossierId) {
        const url = '/getsharekeyasync?dossierId=' + dossierId + '&mediatype=json';
        try {
            const shareKey = await this._httpClient.get(url);

            const saveModalShareKeyElement = Html.select('.modal-save .modal-code');
            saveModalShareKeyElement.innerText = shareKey;

            const shareKeyInputElement = Html.getById('ShareKey');
            shareKeyInputElement.value = shareKey;

            return shareKey;
        } catch (error) {
            console.error(error.message);
            if (error.userFriendlyExceptionMessage) {
                this._modal.setModal(true, error.userFriendlyExceptionMessage);
            }
        }
    }
}

export default DealerForm;